import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import invariant from "tiny-invariant";
import { ETHER } from "./currency";
import { Token, WNATIVE } from "./token";
import { Price } from "./fractions/price";
export var Route = /*#__PURE__*/ function() {
    "use strict";
    function Route(pairs, input, output) {
        _class_call_check(this, Route);
        invariant(pairs.length > 0, "PAIRS");
        invariant(pairs.every(function(pair) {
            return pair.chainId === pairs[0].chainId;
        }), "CHAIN_IDS");
        invariant(_instanceof(input, Token) && pairs[0].involvesToken(input) || input === ETHER && pairs[0].involvesToken(WNATIVE[pairs[0].chainId]), "INPUT");
        invariant(typeof output === "undefined" || _instanceof(output, Token) && pairs[pairs.length - 1].involvesToken(output) || output === ETHER && pairs[pairs.length - 1].involvesToken(WNATIVE[pairs[0].chainId]), "OUTPUT");
        var path = [
            _instanceof(input, Token) ? input : WNATIVE[pairs[0].chainId]
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pairs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _sliced_to_array(_step.value, 2), i = _value[0], pair = _value[1];
                var currentInput = path[i];
                invariant(currentInput.equals(pair.token0) || currentInput.equals(pair.token1), "PATH");
                var _$output = currentInput.equals(pair.token0) ? pair.token1 : pair.token0;
                path.push(_$output);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.pairs = pairs;
        this.path = path;
        this.midPrice = Price.fromRoute(this);
        this.input = input;
        this.output = output !== null && output !== void 0 ? output : path[path.length - 1];
    }
    _create_class(Route, [
        {
            key: "chainId",
            get: function get() {
                return this.pairs[0].chainId;
            }
        }
    ]);
    return Route;
}();
